import { render, staticRenderFns } from "./QuestionsTypeForm.vue?vue&type=template&id=7c327b5b&scoped=true&"
import script from "./QuestionsTypeForm.vue?vue&type=script&lang=js&"
export * from "./QuestionsTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c327b5b",
  null
  
)

export default component.exports